import { ReactComponent as HamburgerMenuIcon } from "../../../svgs/hamburger-menu.svg";
// import { ReactComponent as ProfileIcon } from "../../../svgs/user.svg";
import {
  // Avatar,
  // Divider,
  IconButton,
//   ListItemIcon,
//   ListItemText,
//   Menu,
//   MenuItem,
//   Tooltip,
//   Typography,
} from "@mui/material";
import styles from "./header.module.scss";
// import { useState } from "react";
// import useAuth from "../../../hooks/useAuth";
// import apiCall from "../../../utils/apiCall";
// import { useQuery } from "@tanstack/react-query";
// import { AxiosError } from "axios";
// import { useNavigate } from "react-router-dom";

// interface SingleUserResponse {
//   Message: string;
//   StatusCode: number;
//   Content: Content;
//   Success: boolean;
// }

// interface Content {
//   Id?: any;
//   FirstName?: any;
//   LastName?: any;
//   EmailAddress?: any;
//   PhoneNumber?: any;
//   Roles?: any;
//   CreatedBy?: any;
// }

// interface User {
//   Id: string;
//   FirstName: string;
//   LastName: string;
//   EmailAddress: string;
//   PhoneNumber: string;
//   Roles: Role[];
//   CreatedBy?: any;
// }

// interface Role {
//   RoleId: string;
//   RoleName: string;
//   IsSysAdmin: boolean;
// }

interface HeaderProps {
  handleSidebarToggle?: () => void;
  isMobile: boolean;
}

const Header: React.FC<HeaderProps> = ({ handleSidebarToggle, isMobile }) => {
  // const { user } = useAuth();
  // const navigate = useNavigate();

  // const getProfile = async () => {
  //   return (await apiCall().get(`/Account/GetUserById?userId=${user?.userId}`))
  //     ?.data?.Value as SingleUserResponse;
  // };

  // const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // const open = Boolean(anchorEl);
  // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  // const profileQuery = useQuery(["get-profile", user?.userId], getProfile, {
  //   retry: 0,
  // });

  // const userDetails = profileQuery?.data?.Content as User;
  // const userDetailsError = profileQuery?.error as AxiosError;
  // const userDetailsErrorMessage = userDetailsError?.message;

  // const nthNumber = (number: number) => {
  //   if (number > 3 && number < 21) return "th";
  //   switch (number % 10) {
  //     case 1:
  //       return "st";
  //     case 2:
  //       return "nd";
  //     case 3:
  //       return "rd";
  //     default:
  //       return "th";
  //   }
  // };

  // const getDate = () => {
  //   const date = new Date();
  //   const day = date.getDate();
  //   const month = date.toLocaleString("default", { month: "long" });
  //   const year = date.getFullYear();
  //   const fullDate = [`${day}${nthNumber(day)}`, month, year].join(" ");
  //   return `${fullDate}`;
  // };

  // const goToProfile = () => {
  //   handleClose();
  //   navigate("/profile");
  // };

  return (
    <div className={styles.header}>
      {isMobile && (
        <IconButton
          aria-label="open sidebar"
          edge="start"
          onClick={handleSidebarToggle}
          sx={{ mr: 2, visibility: { xs: "visible", md: "hidden" } }}
        >
          <HamburgerMenuIcon />
        </IconButton>
      )}

      {/* <div className={styles.group}>
        <Tooltip title="My account">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }} alt="Profile picture">
              {userDetails?.FirstName?.slice(0, 1)}
            </Avatar>
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <ListItemText sx={{ marginInline: 2 }}>
            <Typography align="left">
              {userDetails?.FirstName} {userDetails?.LastName}
            </Typography>
            
            <Typography
              sx={{ fontSize: 14 }}
              color="text.secondary"
              align="left"
            >
              {userDetails?.EmailAddress}
            </Typography>
          </ListItemText>
          <Divider />
          <MenuItem onClick={goToProfile}>
            <ListItemIcon>
              <ProfileIcon />
            </ListItemIcon>
            My Profile
          </MenuItem>
        </Menu>
        <span>{getDate()}</span>
      </div> */}
    </div>
  );
};

export default Header;
